import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { authenticationQuery } from '@shared/state/selectors/authentication/authentication.selectors';
import { filter, switchMap, combineLatest, first, Observable } from 'rxjs';
import { IIntercomSettings } from './ate-support.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class IntercomInitService {
  private _hasPushedToDataLayer = false;

  constructor(
    private store: Store,
    private _http: HttpClient
  ) {
    this.store
      .select(authenticationQuery.getIsLoggedIn)
      .pipe(
        filter(isLoggedIn => isLoggedIn),
        switchMap(() =>
          combineLatest([this.store.select(authenticationQuery.getUser).pipe(first()), this.store.select(authenticationQuery.getAuth).pipe(first())])
        ),
        first()
      )
      .subscribe(([user, auth]) => {
        if (!user || !auth?.accessToken || this._hasPushedToDataLayer) return;

        this._hasPushedToDataLayer = true;

        const tempIntercomSettings = {
          app_id: environment.intercomAppId,
          user_id: user.userId,
          email: user.email,
          created_at: Math.floor(Date.now() / 1000)
        };

        window.intercomSettings = tempIntercomSettings;

        this.getSettings()
          .pipe(first())
          .subscribe((settings: IIntercomSettings) => {
            window.intercomSettings = settings;

            // 🔥 Push to GTM dataLayer here
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'intercomUserBoot',
              intercom_user_jwt: settings.user_hash,
              user_id: settings.user_id
            });
          });
      });
  }

  private getSettings(): Observable<IIntercomSettings> {
    const { app_id } = window.intercomSettings ?? {};
    const httpOptions = {
      params: { appId: app_id },
      headers: new HttpHeaders({
        'Content-Type': 'application/ate.supplier.v1+json'
      })
    };

    return this._http.get<IIntercomSettings>(`${environment.supplierApiGateway}/sup/intercom/settings`, httpOptions);
  }
}
